import BaseError from './BaseError';

class InvalidArgumentError extends BaseError {
  constructor(message, componentName) {
    super(`Component ${componentName}: ${message}`);
  }
}

export default InvalidArgumentError;
